import { render, staticRenderFns } from "./PointBankAnotherlane.vue?vue&type=template&id=5e053ee3"
import script from "./PointBankAnotherlane.vue?vue&type=script&lang=js"
export * from "./PointBankAnotherlane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports